import classnames from 'classnames'
import Formsy from 'formsy-react'

import { withTranslate } from 'i18n/utils'
import featureToggles from 'shared/featureToggles'
import DocumentDataFields from '@components/DocumentDataFields'
import FormsyInput from '@components/Textfield/withFormsy'

import guestBookingStyles from 'booking/components/GuestCheckoutComponents/styles.module.scss'
import styles from 'purchase-flow/brazil/components/styles.module.scss'

const PersonalDetails = ({ formData, onChangeFormData }) => {
    const [isUsingBoleto, setIsUsingBoleto] = React.useState(false)

    const boletoClassName = classnames(styles.boleto, guestBookingStyles.personalDetailsFormContainer, {
        [styles.selected]: isUsingBoleto,
    })

    return (
        <div className={'mt-5'}>
            <h3 className="font-weight-bold text-uppercase mb-4">
                <T>guest.booking.review.pay.personal.details.label</T>
            </h3>
            <div className={boletoClassName} onClick={setIsUsingBoleto}>
                <PersonalDetailsForm formData={formData} onChangeFormData={onChangeFormData} />
            </div>
        </div>
    )
}

const $PersonalDetailsForm = ({ formData, onChangeFormData, translate: t }) => (
    <Formsy className={guestBookingStyles.personalDetailsInputContainer}>
        <FormsyInput
            className="mt-1 mb-1"
            name="firstName"
            value={formData.firstName}
            type="text"
            label={t('guest.booking.personal.details.form.first.name')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            required
        />
        <FormsyInput
            className="mt-1 mb-1"
            name="lastName"
            value={formData.lastName}
            type="text"
            label={t('guest.booking.personal.details.form.last.name')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            required
        />
        <FormsyInput
            className="mt-1 mb-1"
            name="email"
            value={formData.email}
            type="email"
            label={t('guest.booking.personal.details.form.email')}
            validationError={t('input.email.pattern.mismatch.error.message')}
            validations="isEmail"
            onChange={onChangeFormData}
            required
        />
        <FormsyInput
            className="mt-1 mb-1"
            name="phone"
            value={formData.phone}
            type="text"
            label={t('guest.booking.personal.details.form.phone')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            required
        />
        {featureToggles.brNeoPurchaseFlow && (
            <DocumentDataFields
                onChange={onChangeFormData}
                fieldClassName={guestBookingStyles.documentDataField}
                documentType={formData.documentType}
            />
        )}
    </Formsy>
)

const PersonalDetailsForm = compose(withTranslate)($PersonalDetailsForm)

export default PersonalDetails
